import React, { Component } from "react";
import { connect } from "react-redux";

import Header from "./Header";
import MediaList from "Common/MediaList";
import MediaListSlick from "./MediaListSlick";
import MediaListByCat0 from "./MediaListSlick/MediaListByCat0";
import MediaListByCat1 from "./MediaListSlick/MediaListByCat1";
import MediaListByCat2 from "./MediaListSlick/MediaListByCat2";
import MediaListByCat3 from "./MediaListSlick/MediaListByCat3";
import MediaListByCat4 from "./MediaListSlick/MediaListByCat4";

import TopMedia from "./TopMedia";
import AlbumList from "Common/AlbumList";
import AddMedia from "../Reveal/AddMedia/AddMedia";
import BubblesListContainer from "../BubblesList/BubblesListContainer";
import SidebarContainer from "../Sidebar/SidebarContainer";
import SelectAlbumContainer from "./SelectAlbum/SelectAlbumContainer";
import DeleteConfirm from "Common/Confirm/DeleteConfirm";
import { ToastContainer, toast } from "react-toastify";
import { BUBBLE_EVENTS } from "Config";

import {
  setCurrentNavPage,
  setAddMediaModalOpened,
  setOpenDeleteConfirm,
  resetFilter
} from "Actions";
import { fetchAlbums, fetchTopMedias, deleteMedias } from "Thunks";

import styles from "./Community.local.scss";
//import classnames from "classnames";
import _ from "i18n";
import NotFound from "Common/NotFound";

export class Community extends Component {
  state = {
    addMediaModalOpened: false
  };

  componentDidMount() {
    const { fetchAlbums, resetFilter, fetchTopMedias } = this.props;
    //setCurrentNavPage("COMMUNITY_PAGE");
    resetFilter();
    fetchAlbums({ limit: 12 });
    fetchTopMedias({ limit: 12 });
  }

  renderBubbles() {
    const { checks, user } = this.props;
    const bubbles = [
      {
        icon: "i-plus",
        label: _("Add new medias"),
        event: BUBBLE_EVENTS.ADD_NEW_MEDIA
      },
      {
        icon: "i-folder",
        label: _("Add to album"),
        event: BUBBLE_EVENTS.ADD_TO_ALBUM,
        hidden: checks && checks.length < 1
      },
      {
        icon: "i-mask",
        label: _("Maske medias"),
        hidden: checks && checks.length < 1,
        event: BUBBLE_EVENTS.MASK_MEDIAS
      },
      {
        icon: "i-archive",
        label: _("Archive medias"),
        hidden: checks && checks.length < 1,
        event: BUBBLE_EVENTS.ARCHIVE_MEDIAS
      },
      {
        icon: "i-trash",
        label: _("Delete medias"),
        hidden: checks && checks.length < 1,
        event: BUBBLE_EVENTS.DELETE_MEDIAS
      }
    ];
    if (user) return <BubblesListContainer bubbles={bubbles} active={true} />;
    else return null;
  }

  renderSelectAlbum() {
    return <SelectAlbumContainer />;
  }

  renderSidebar() {
    const { displaySidebarAlbums } = this.props;

    if (!displaySidebarAlbums) {
      return null;
    }
    return (
      <SidebarContainer content={this.renderSelectAlbum()} withMask={true} />
    );
  }

  handleDeleteMedias = () => {
    const { checks, deleteMedias } = this.props;
    const mediaIds = checks.map(media => media.id);
    deleteMedias(mediaIds)
      .then(resp => {
        setOpenDeleteConfirm(false);
        let message = _("Medias deleted successfully");
        if (resp.value.data.warning) {
          message = _(resp.value.data.warning.message);
          toast.error(
            <div className="flashMessage">
              <div className="flahMessage__icon">
                <i className="icotam-close-outline" />
              </div>
              <div className="flashMessage__body">
                <h5>{_("Error")}</h5>
                <p>{message}</p>
              </div>
            </div>
          );
        } else {
          toast.success(
            <div className="flashMessage">
              <div className="flahMessage__icon">
                <i className="icotam-check-outline" />
              </div>
              <div className="flashMessage__body">
                <h5>{_("Success")}</h5>
                <p>{message}</p>
              </div>
            </div>
          );
        }

        return resp;
      })
      .catch(e => {
        setOpenDeleteConfirm(false);
        toast.error(
          <div class="flashMessage">
            <div class="flahMessage__icon">
              <i className="icotam-close-outline" />
            </div>
            <div className="flashMessage__body">
              <h5>{_("Error")}</h5>
              <p>{_("Error when deleting medias")}</p>
            </div>
          </div>
        );
      });
  };

  cancelDeleteMedias = () => {
    const { setOpenDeleteConfirm } = this.props;
    setOpenDeleteConfirm(false);
  };

  renderDeleteModal() {
    const { openDeleteConfirm, deleting } = this.props;

    return (
      <DeleteConfirm
        isOpen={openDeleteConfirm}
        onCancel={this.cancelDeleteMedias}
        onConfirm={this.handleDeleteMedias}
        deleting={deleting}
        text={_("Are you sure you want to delete selected medias ?")}
      />
    );
  }

  render() {
    const {
      albums,
      addMediaModalOpened,
      setAddMediaModalOpened,
      medias,
      fetching,
      filter,
      lng
    } = this.props;
    const nameAttr = `name${lng.charAt(0).toUpperCase() + lng.slice(1)}`;

    return (
      <div className={styles.community}>
        <Header community={this.props.community} />
        {this.renderBubbles()}
        {/* <FixedBtn
          onClick={() => this.setState({ addMediaModalOpened: true })}
          text={_("Add new medias")}
          icon="icon-plus"
          style={{ top: "40%" }}
        /> */}
        <AddMedia
          isOpen={addMediaModalOpened}
          onRequestClose={() => {
            setAddMediaModalOpened(false);
          }}
        />
        {/* <FixedBtn
          text={_("Add to an album")}
          icon="icon-folder-alt"
          style={{ top: "50%" }}
        /> */}
        {filter.type !== "ALBUM" ? (
          <div className={styles.body}>
            {filter.category || filter.tags.length > 0 ? (
              <section className="mb-20">
                <h2>
                  {filter.tags && filter.tags.length > 0
                    ? _("Result of the research") +
                      " (" +
                      filter.tags[0][nameAttr] +
                      ")"
                    : filter.category[nameAttr]}
                </h2>
                {medias.length < 1 && !fetching ? (
                  <NotFound />
                ) : (
                  <MediaList medias={medias} fetching={fetching} />
                )}
              </section>
            ) : (
              <div>
                <MediaListSlick order="all" />
                <MediaListByCat0 />
                <MediaListByCat1 />
                <MediaListByCat2 />
                <section>
                  <TopMedia />
                </section>
                <MediaListByCat3 />
                <MediaListByCat4 />
                {this.renderDeleteModal()}
                <ToastContainer hideProgressBar />
              </div>
            )}
          </div>
        ) : null}

        {albums &&
          albums.items &&
          albums.items.length > 0 && (
            <section className={styles.album}>
              <div className={styles.albumHeader}>
                <h2>{_("Medias Albums")}</h2>
              </div>
              <AlbumList albums={albums.items} fetching={albums.fetching} />
            </section>
          )}
        {this.renderSidebar()}
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  filter: state.filter.filterState,
  fetching: state.medias.listing.fetching,
  fetched: state.medias.listing.fetched,
  medias: state.medias.listing.items,
  community: state.auth.navCommunity,
  user: state.auth.user,
  albums: state.albums,
  checks: state.medias.listing.checks,
  deleting: state.medias.listing.deleting,
  openDeleteConfirm: state.medias.listing.openDeleteConfirm,
  addMediaModalOpened: state.usedMedias.addMediaModalOpened,
  displaySidebarAlbums: state.eventFired.displaySidebarAlbums,
  lng: state.params.lng
});

const mapDispatchToProps = dispatch => ({
  setCurrentNavPage: page => dispatch(setCurrentNavPage(page)),
  fetchAlbums: params => dispatch(fetchAlbums(params)),
  fetchTopMedias: params => dispatch(fetchTopMedias(params)),
  setOpenDeleteConfirm: visible => dispatch(setOpenDeleteConfirm(visible)),
  setAddMediaModalOpened: visible => dispatch(setAddMediaModalOpened(visible)),
  deleteMedias: ids => dispatch(deleteMedias(ids)),
  resetFilter: () => dispatch(resetFilter())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Community);



// WEBPACK FOOTER //
// ./src/components/Community/index.js